import { userAuthContextType } from '../../auth/AuthProvider';
import { axios, getResponse, settings } from '../../helpers/main';

const { backend } = settings;
const authServices = { user: userAuthContextType }; //eslint-disable-line
const objectService = getResponse({ type: 0 }); //eslint-disable-line

/**
 * Service to manage communication with the Profile/Users API.
 * Follows the Single Responsibility Principle (SRP) by separating network logic from the UI.
 */
export const ProfileService = {
    /**
     * Retrieves user data by ID, including company and customer access information.
     * @param {Object} params - Parameters.
     * @param {authServices} params.auth - User authentication object.
     * @param {number|string} params.id - User ID to retrieve.
     * @param {number} params.languageId - Current language ID.
     * @param {string} [params.subMethod=''] - Sub-method name for error traceability.
     * @returns {Promise<objectService>} Promise with the API response.
     */
    getByIdWithCompaniesAccess: async ({ auth, id, languageId, subMethod = '' } = {}) => {
        const requestObj = {
            url: `${backend?.urls?.api}${backend?.urls?.apiV1}${backend?.urls?.users}/`,
            headers: {
                authorization: `bearer ${auth?.user?.token?.token}`,
            },
            data: {
                id: id,
                method: backend?.methods?.users?.getByIdWithCompaniesAccess,
                languageId: languageId,
            },
            subMethod: subMethod,
        };
        return await axios.post(requestObj);
    },

    /**
     * Updates user profile data.
     * @param {Object} params - Parameters.
     * @param {authServices} params.auth - User authentication object.
     * @param {Object} params.user - User data to update.
     * @param {number} params.languageId - Current language ID.
     * @param {string} [params.subMethod=''] - Sub-method name for error traceability.
     * @returns {Promise<objectService>} Promise with the API response.
     */
    update: async ({ auth, user, languageId, subMethod = '' } = {}) => {
        const requestObj = {
            url: `${backend?.urls?.api}${backend?.urls?.apiV1}${backend?.urls?.users}/${user?.id}`,
            headers: {
                authorization: `bearer ${auth?.user?.token?.token}`,
            },
            data: {
                data: user,
                method: backend?.methods?.users?.getByIdWithCompaniesAccess,
                languageId: languageId,
            },
            subMethod: subMethod,
        };
        return await axios.post(requestObj);
    },

    /**
     * Changes the user's password.
     * @param {Object} params - Parameters.
     * @param {authServices} params.auth - User authentication object.
     * @param {Object} params.passwordObj - Password change data (userId, password, newPassword, etc.).
     * @param {number} params.languageId - Current language ID.
     * @param {string} [params.subMethod=''] - Sub-method name for error traceability.
     * @returns {Promise<objectService>} Promise with the API response.
     */
    passwordChange: async ({ auth, passwordObj, languageId, subMethod = '' } = {}) => {
        const requestObj = {
            url: `${backend?.urls?.api}${backend?.urls?.apiV1}${backend?.urls?.users}/`,
            headers: {
                authorization: `bearer ${auth?.user?.token?.token}`,
            },
            data: {
                data: passwordObj,
                languageId: languageId,
                method: backend?.methods?.users?.passwordChange,
            },
            subMethod: subMethod,
        };
        return await axios.post(requestObj);
    },
};
